import { formatDate } from 'app/utils';
import { ConditionalLink, Flex, Hr } from 'components';
import React from 'react';
import styled from 'styled-components';

interface RecommendationProps {
  companyName: string;
  symbolCode: string;
  highlighted?: boolean;
  title: string;
  updatedAt: string;
  link: string;
  // strategy: string;
  // order: number;
  // viewCount: number;
  // createdAt: string;
  // viewedAt?: string;
  // releaseDate?: string;
}

const CardHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: space-start;
  padding: 1rem;
  z-index: 5;
`;

const CardCompanyWrapper = styled.div``;

const CardCompanySymbol = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  color: white;
  text-transform: uppercase;
`;

const CardCompanyName = styled.div`
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  color: ${({ theme }) => theme.colors.white50};
  margin-top: 4px;
`;

// const CardCompanyImageWrapper = styled.div`
//   width: 42px;
//   height: 42px;
//   background: ${({ theme }) => theme.colors.white25};
//   border-radius: 21px;
//   flex-shrink: 0;
// `;

// const CardCompanyImage = styled.img``;

const CardFoot = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  z-index: 5;
`;

const CardFooItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardFooItemLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
  color: ${({ theme }) => theme.colors.white25};
`;

const CardFooItemValue = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1;
  color: white;
  margin-top: 4px;
`;

const CardStatusWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-left: 1rem;
  z-index: 5;
`;

const CardStatus = styled.div`
  font-size: 0.75rem;
  font-weight: 900;
  text-transform: uppercase;
  background: ${({ theme }) => theme.colors.alert_400};
  padding: 2px 6px;
  color: white;
  border-radius: 4px;
`;

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  border-radius: 3px;
`;

const CardWrapper = styled(ConditionalLink)`
  width: 280px;
  height: 160px;
  border-radius: 4px;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  background: ${({ theme }) => theme.colors.dark_150};
  border: 1px solid ${({ theme }) => theme.colors.dark_150};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary_400};
    ${Background} {
      background: linear-gradient(0deg, ${({ theme }) => theme.colors.primary_400}, ${({ theme }) => theme.colors.primary_400}),
        ${({ theme }) => theme.colors.dark_150};
      opacity: 0.1;
    }
  }
`;

const Recommendation = ({ companyName, symbolCode, highlighted, link, title, updatedAt }: RecommendationProps) => {
  return (
    <CardWrapper type="internal" to={link}>
      <CardHead>
        <CardCompanyWrapper>
          <CardCompanySymbol>{symbolCode}</CardCompanySymbol>
          <CardCompanyName>{companyName}</CardCompanyName>
        </CardCompanyWrapper>

        {/* <CardCompanyImageWrapper>
          <CardCompanyImage />
        </CardCompanyImageWrapper> */}
      </CardHead>

      {highlighted ? (
        <CardStatusWrapper>
          <CardStatus>Novo Status</CardStatus>
        </CardStatusWrapper>
      ) : (
        <Flex flexGrow={0} px={3} zIndex={5}>
          <Hr my={0} color="gray_600" />
        </Flex>
      )}

      <CardFoot>
        <CardFooItem>
          <CardFooItemLabel>ATUALIZADO: {formatDate(updatedAt).format('DD/MM/YYYY HH[:]mm')}</CardFooItemLabel>
          <CardFooItemValue>{title}</CardFooItemValue>
        </CardFooItem>
      </CardFoot>

      <Background />
    </CardWrapper>
  );
};

export default Recommendation;
